import { render, staticRenderFns } from "./FiltroProduto.vue?vue&type=template&id=9ca468e0&scoped=true"
import script from "./FiltroProduto.vue?vue&type=script&lang=js"
export * from "./FiltroProduto.vue?vue&type=script&lang=js"
import style0 from "./FiltroProduto.vue?vue&type=style&index=0&id=9ca468e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca468e0",
  null
  
)

export default component.exports